import React, { useContext, useEffect, useState } from "react";
import SidebarList from "./SidebarList";
import DocumentView from "./DocumentView";
import {
	saveDraftJson,
	resetReadOnlyDoc,
	getDocumentsById,
	findDocumentsById,
	getUnlabeledFileDoc,
	appendDocumentsById,
	getFile,
	getElasticSearchDocuments,
	prevFileData,
	getDennisConfiguration
} from "../../context/actions/document";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { pagination, documentFilterItems, toasterConfig } from '../../utils/constants';
import '../../assets/css/common/document/index.scss';
import { SocketContext } from '../../context/actions/socket';
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import DennisFile from "../DennisFile";
import LoaderUI from "../../components/common/loader/index";
import DraftUnlabeledData from './DocumentView/draftModal/index'
import { updateCompleteStatus, getDocumentTypeRules } from '../../context/actions/document';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import BackButton from "../../components/common/BackButton";
import DocAssistWindowManager from "./../DocumentDetail/DocAssistWindowManager"; // Import the window manager

let docAssistWindow;
DocAssistWindowManager.init();

var _ = require('lodash');
const MySwal = withReactContent(Swal);

const UnlabeledDocumentDetail = () => {
	const location = useLocation();
	const history = useHistory();

	const [filterSelected, setFilterSelected] = useState();
	const [sortBySelected, setSortBySelected] = useState(2);
	const navigationState = useSelector((state) => state.navigationReducer.isOn);

	let totalDocRecords = useSelector((state) => state.document.totalDocRecords);
	const dispatch = useDispatch();
	const actPage = useSelector(state => state.general.page !== "" ? state.general.page : pagination.page)
	const [sidebarLoading, setSidebarLoading] = useState(false);
	const [sidebarLoadingLabel, setSidebarLoadingLabel] = useState('View More');
	const [sidbarLoadingButton, setSidbarLoadingButton] = useState(false);
	const [page, setPage] = useState(actPage);
	const [paginations] = useState(10);
	const [loader, setLoader] = useState(false);
	const [showTab, setShowTab] = useState(false);
	const folder = useSelector((state) => state?.document?.folder || null);
	const files = useSelector((state) => state?.document?.docRecords)
	const [hasPrevPage, setHasPrevPage] = useState(location?.state?.hasPrevPage)
	const [hasNextPage, setHasNextPage] = useState(location?.state?.hasNextPage)
	const myAssigned = useSelector((state) => state?.document?.myAssigned)
	const userDetail = useSelector((state) => state?.user?.user);

	// console.log('files',files)
	const [innerLoader, setInnerLoader] = useState(false);


	const [title, setTitle] = useState(location?.state?.title ? location?.state?.title : "")

	let [payload, setPayload] = useState({ folder: folder, limit: paginations, page: page, deleted: false, otherDocuments: true });
	let [elasticPayload, setElasticPayload] = useState({ folder: folder });
	const [elasticSearchList, setElasticSearchList] = useState([]);
	let [focusSearchFlag, setFocusSearchFlag] = useState(false);
	const [filePage, setFilePage] = useState(pagination.page);

	const [sortFn, setSortFn] = useState(0);

	// const currentDocument = useSelector((state) => state.document.documentData);
	// console.log(currentDocument,"document")

	const [currentDocument, setCurrentDocument] = useState({})
	const [modelData, setModelData] = useState({})

	let [pageNumber, setPageNumber] = useState(1)

	const [showModal, setShowModel] = useState(false);
	const [draftJsonFlag, setDraftJsonFlag] = useState(false);
	const [selectedId, setSelectedId] = useState("");
	const [draft, setDraft] = useState({});
	const [userName, setUserName] = useState(" ")

	const [docId, setDocId] = useState(location?.state?.documentExclude ? location?.state?.documentExclude : "")
	const [sidebarActivePacketIndex, setSidebarActivePacketIndex] = useState(location?.state?.sidebarActivePacketIndex ? location?.state?.sidebarActivePacketIndex : "")
	const [select_Folder_id, setSelect_Folder_id] = useState(location?.state?.select_Folder_id ? location?.state?.select_Folder_id : "")

	const [bgColor, setBgColor] = useState('#fff');

	// const docAssistWindowRef = useRef(null);

	useEffect(() => {
		if (!currentDocument || Object.keys(currentDocument).length === 0) return;
		dispatch(getDocumentTypeRules({ organization: currentDocument?.organization, docType: 'dennis' }, () => { }))
		const documentTypeId = currentDocument?.packet_type?._id;
		const organizationId = currentDocument?.organization;
		// Calculate dimensions and position for the window
		const width = window.innerWidth * 0.5;
		const height = window.innerHeight * 0.8;
		const gap = 20;
		const left = window.innerWidth - width - gap;
		const top = window.innerHeight - height + 2 * gap;
		// Construct URL for the docAssistRules page
		const docAssistUrl = `/docAssistRules?packetId=${'dennis'}&orgId=${organizationId}`;
		// Use the window manager to open or update the docAssist window
		DocAssistWindowManager.openOrUpdateDocAssistWindow(docAssistUrl, width, height, left, top);
	}, [currentDocument]);



	// console.log('fileData',currentDocument)
	const nextDoc = (id) => {
		console.log("id", id)
		let pageNumber = page;
		let i = Array.isArray(files) ? files.findIndex((cur) => cur._id === id) : -1;
		if (files.length == 1) {
			pageNumber = pageNumber - 1;
			setPage(pageNumber);
		}
		setSidebarLoadingLabel('loading');
		payload = { ...payload, page: pageNumber, otherDocuments: true, myAssigned: myAssigned }
		dispatch(appendDocumentsById(payload, ((result) => {
			if (result?.docs && result?.docs.length) {
				if (result.docs[i]) {
					_moveToNextId(result.docs[i]._id)
					setHasPrevPage(result?.hasPrevPage)
					setSelectedId(result?.docs[i]?._id);
					setHasNextPage(result?.hasNextPage)
					setSidebarLoading(false);
					setSidebarLoadingLabel('View More');
					setShowModel(false)

				} else {
					_moveToNextId(result.docs[0]._id)
					setHasPrevPage(result?.hasPrevPage)
					setSelectedId(result?.docs[0]?._id);
					setHasNextPage(result?.hasNextPage)
					setSidebarLoading(false);
					setSidebarLoadingLabel('View More');
					setShowModel(false)

				}

			} else {
				history.push("/documents");

			}
		}))
		)
	}

	useEffect(() => {
		dispatch({ type: "ISLOADING", data: true });
		dispatch(
			getUnlabeledFileDoc({ docId: docId, Au: null, pageNumber: 1 }, (result) => {
				dispatch({ type: "ISLOADING", data: false });
				if (result) {
					setCurrentDocument(result);
					setPayload(result.complete == true || currentDocument?.reviewLabeled == true ? { folder: folder, limit: paginations, page: page, deleted: false, otherDocuments: true, complete: true, reviewLabeled: true } : { folder: folder, limit: paginations, page: page, deleted: false, otherDocuments: true })
					setUserName(result?.user ? result?.user?.fname + " " + result?.user?.lname : result?.admin?.fname + " " + result?.admin?.lname);
					setModelData({})
					if (result?.original_json.hasOwnProperty("model_identifier") && result?.original_json?.model_identifier) {
						dispatch(getDennisConfiguration({ docId: docId, modelIdentifier: result?.original_json?.model_identifier }, (result) => {
							dispatch({ type: "ISLOADING", data: false });
							if (result) {
								setModelData(result)
							} else {
								setModelData({})
							}
						}))
					}
				}
			})
		);
	}, []);

	// const [textChange, setTextChange] = useState([]);
	const filterSelectedFn = (val) => {
		setFilterSelected(val)
	}
	const sortBySelectedFn = (val) => {
		setSortBySelected(val)
	}

	const _advanceFilter = async (val) => {
		setSortFn(0)  // to not trigger default sort fuctionality in filemenus component when desc/ asc is clicked
		setInnerLoader(true);
		let advFilter = documentFilterItems[val]
		payload = { ...payload, ...advFilter };
		setPage(1);
		payload = { ...payload, ...advFilter, parentName: "Unlabeled Document", otherDocuments: true, myAssigned: myAssigned }
		elasticPayload = { ...payload, ...advFilter, parentName: "Unlabeled Document", page: 1, myAssigned: myAssigned }
		setElasticSearchList([]);
		setElasticPayload(elasticPayload);
		setPayload(payload);
		if (val.trim()) {
			elasticPayload = { ...elasticPayload, name: val }
			setElasticPayload(elasticPayload)
			await dispatch(getElasticSearchDocuments(elasticPayload, ((result) => {
				setInnerLoader(false);
				setElasticSearchList(result?.hits?.hits);
				setFocusSearchFlag(true);
			})));
		}
		dispatch(getDocumentsById(payload, ((result) => {
			if (result.docs !== undefined && result.docs.length) {
				_handleSelected(result.docs[0]._id)
				setHasPrevPage(result?.hasPrevPage)
				setSelectedId(result?.docs[0]?._id);
				setHasNextPage(result?.hasNextPage)
			}
			setSidebarLoading(false);
			setInnerLoader(false);
			setSidebarLoadingLabel('View More');
		})));
	}


	/**
	 * @description method call to search documents from leftside bar listing 
	 * @param {*} val 
	 * @returns 
	 */




	const __advanceFilter = async (sortBy, order) => {
		setSortFn(1)
		setInnerLoader(true);
		setLoader(true);
		payload = { ...payload, parentName: "Unlabeled Document", sort: sortBy, order: order, page: 1, myAssigned: myAssigned }
		if (currentDocument?.complete == true || currentDocument?.reviewLabeled == true) {
			payload = { ...payload, parentName: "labeled Document", complete: true, reviewLabeled: true }
		}
		setPayload(payload);
		setPage(1);
		dispatch(findDocumentsById(payload, ((result) => {
			setHasNextPage(result?.hasNextPage)
			setHasPrevPage(result?.hasPrevPage)
			if (result.docs !== undefined && result.docs.length) {
				_handleSelected(result.docs[0]._id)
				setHasPrevPage(result?.hasPrevPage)
				setSelectedId(result?.docs[0]?._id);
				setHasNextPage(result?.hasNextPage)

			}
			setSidebarLoading(false);
			setLoader(false);
			setInnerLoader(false);
			setSidebarLoadingLabel('View More');
		})));

	}


	const _resetFilter = () => {
		setInnerLoader(true);
		setPage(1);
		setLoader(true);
		if (currentDocument?.complete == true || currentDocument?.reviewLabeled == true) {
			payload = { parentName: "labeled Document", folder: folder, limit: paginations, page: 1, otherDocuments: true, myAssigned: myAssigned, complete: true, reviewLabeled: true }
		} else {
			payload = { parentName: "Unlabeled Document", folder: folder, limit: paginations, page: 1, otherDocuments: true, myAssigned: myAssigned }
		}

		setPayload(payload);
		setFocusSearchFlag(false);
		setElasticSearchList([]);
		setElasticPayload(currentDocument?.complete == true || currentDocument?.reviewLabeled == true ? { folder: folder, otherDocuments: true, myAssigned: myAssigned, complete: true, reviewLabeled: true } : { folder: folder, otherDocuments: true, myAssigned: myAssigned });
		dispatch(findDocumentsById(payload, ((result) => {
			if (result.docs !== undefined && result.docs.length) {
				_handleSelected(result.docs[0]._id)
				setHasPrevPage(result?.hasPrevPage)
				setSelectedId(result?.docs[0]?._id);
				setHasNextPage(result?.hasNextPage)
			}
			setSidebarLoading(false);
			setInnerLoader(false);
			setLoader(false);
			setSidebarLoadingLabel('View More');
		})));
	}



	const _handlePageChange = (activePage) => {
		setPage(activePage);
		setSidebarLoading(true);
		setSidebarLoadingLabel('loading');

		payload = { ...payload, parentName: "Unlabeled Document", page: activePage, otherDocuments: true, myAssigned: myAssigned }
		if (currentDocument?.complete == true || currentDocument?.reviewLabeled == true) {
			payload = { ...payload, parentName: "labeled Document", complete: true, reviewLabeled: true }
		}
		// console.log(payload)
		dispatch(appendDocumentsById(payload, ((result) => {
			// console.log(result)
			_handleSelected(result.docs[0]._id)
			setHasPrevPage(result?.hasPrevPage)
			setSelectedId(result?.docs[0]?._id);
			setHasNextPage(result?.hasNextPage)
			setSidebarLoading(false);
			setSidebarLoadingLabel('View More');
		})));
	}
	const handleTabChange = () => {
		setShowTab(!showTab)
	}

	/**
	* @description funnction call to search value by elasticsearc
	* @param {string} param search value
	 */

	const _elasticSearch = async (val) => {
		if (val.trim()) {
			if (currentDocument?.complete == true || currentDocument?.reviewLabeled == true) {
				elasticPayload = { ...elasticPayload, parentName: "labeled Document", name: val, otherDocuments: true, myAssigned: myAssigned, complete: true, reviewLabeled: true }
			} else {
				elasticPayload = { ...elasticPayload, parentName: "Unlabeled Document", name: val, otherDocuments: true, myAssigned: myAssigned }
			}
			setElasticPayload(elasticPayload)
			await dispatch(getElasticSearchDocuments(elasticPayload, ((result) => {
				setInnerLoader(false);
				setElasticSearchList(result?.hits?.hits);
				setFocusSearchFlag(true);
			})));
		} else {
			setElasticSearchList([])
		}

	};

	const _docSearch = async (val) => {
		setPage(1);
		setInnerLoader(true);
		setLoader(true);
		payload = { ...payload, parentName: "Unlabeled Document", fields: "name", filter: val, page: 1, otherDocuments: true, myAssigned: myAssigned }
		setPayload(payload);
		dispatch(findDocumentsById(payload, ((result) => {
			if (result.docs !== undefined && result.docs.length) {
				_handleSelected(result.docs[0]._id)
			}
			setSidebarLoading(false);
			setLoader(false);
			setInnerLoader(false);
			setLoader(false);
			setSidebarLoadingLabel('View More');
		})));

	};


	const _handleSelected = async (id) => {
		if (draftJsonFlag && !(currentDocument?.complete || currentDocument?.reviewLabeled)) {
			console.log("draft", draft)
			setSelectedId(id)
			setShowModel(true)
		} else {
			setPageNumber(1)
			setLoader(true);
			dispatch(
				getUnlabeledFileDoc({ docId: id, Au: null }, (result) => {
					setCurrentDocument(result)
					const uniqueIdentifier = new Date().getTime();
					history.push(`?timestamp=${uniqueIdentifier}`, { ...location?.state, documentExclude: id });
					setUserName(result?.user ? result?.user?.fname + " " + result?.user?.lname : result?.admin?.fname + " " + result?.admin?.lname);
					setLoader(false)
					setModelData({})
					if (result?.original_json.hasOwnProperty("model_identifier") && result?.original_json?.model_identifier) {
						dispatch(getDennisConfiguration({ docId: docId, modelIdentifier: result?.original_json?.model_identifier }, (result) => {
							dispatch({ type: "ISLOADING", data: false });
							if (result) {
								setModelData(result)
							} else {
								setModelData({})
							}
						}))
					}
					localStorage.setItem('loggedInOrg', `${userDetail?._id}`)
					dispatch(getDocumentTypeRules({ organization: result.organization, docType: 'dennis' }, () => { }))
				})
			);
		}
	};

	const _moveToNextId = async (id) => {

		setPageNumber(1)
		setLoader(true);
		dispatch(
			getUnlabeledFileDoc({ docId: id, Au: null }, (result) => {
				setCurrentDocument(result)
				setUserName(result?.user ? result?.user?.fname + " " + result?.user?.lname : result?.admin?.fname + " " + result?.admin?.lname);
				setLoader(false)
				setModelData({})
				if (result?.original_json.hasOwnProperty("model_identifier") && result?.original_json?.model_identifier) {
					dispatch(getDennisConfiguration({ docId: docId, modelIdentifier: result?.original_json?.model_identifier }, (result) => {
						dispatch({ type: "ISLOADING", data: false });
						if (result) {
							setModelData(result)
						} else {
							setModelData({})
						}
					}))
				}
			})
		);

	};

	const makeDraft = async () => {
		setDraftJsonFlag(false)
		setShowModel(false)
		setPageNumber(1)
		setLoader(true);
		dispatch(
			saveDraftJson({ draftJson: draft, docId: currentDocument._id }, (result) => {
				// toast.success("", toasterConfig);
			})
		)
		dispatch(
			getUnlabeledFileDoc({ docId: selectedId, Au: null }, (result) => {
				setCurrentDocument(result)
				setUserName(result?.user ? result?.user?.fname + " " + result?.user?.lname : result?.admin?.fname + " " + result?.admin?.lname);
				setLoader(false)
				setModelData({})
				if (result?.original_json.hasOwnProperty("model_identifier") && result?.original_json?.model_identifier) {
					dispatch(getDennisConfiguration({ docId: docId, modelIdentifier: result?.original_json?.model_identifier }, (result) => {
						dispatch({ type: "ISLOADING", data: false });
						if (result) {
							setModelData(result)
						} else {
							setModelData({})
						}
					}))
				}
			})
		);
	}

	const changeFile = () => {
		setShowModel(false)
		// setPageNumber(1)
		// setLoader(true);
		// dispatch(
		// 	getUnlabeledFileDoc({ docId:selectedId, Au: null}, (result) => {
		// 		setLoader(false)
		// 	})
		// );

	}


	const focusSearch = (val) => {
		setFocusSearchFlag(val);
	}


	// useEffect(() => {
	// 	return () => {
	// 		//dispatch(navigationAction(false));
	// 		//dispatch(navigationAction2(false));
	// 	}
	// }, [files, paginations, page, filePage, dispatch]);

	useEffect(() => {

		if (totalDocRecords && totalDocRecords > paginations * page) {
			setSidbarLoadingButton(true)
		} else {
			setSidbarLoadingButton(false)
		}
	});




	//   console.log('setLoader',loader)

	const updateDocumentViewData = (data) => {
		setPageNumber(data.ai_properties.page_index + 1)
	};

	const backClick = () => {
		history.push("/documents", { activeLoan: sidebarActivePacketIndex, _select_Folder_id: select_Folder_id, myAssigned: myAssigned });
	}

	const [timer, setTimer] = useState(new Date());

	useEffect(() => {
		setTimer(new Date());
	}, [])

	const markCompleted = (id, version) => {




		MySwal.fire({
			title: "Mark as Complete",
			text: "Are you sure you want to Mark this complete?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Yes",
		}).then((result) => {
			if (result.isConfirmed) {
				dispatch(updateCompleteStatus({ docId: id, version: version, validationCompletionTime: Math.round((new Date() - timer) / 1000) }, (res) => {
					if (res) {
						setTimer(new Date());
						let pageNumber = page;
						let i = Array.isArray(files) ? files.findIndex((cur) => cur._id === id) : -1;
						if (files.length == 1) {
							pageNumber = pageNumber - 1;
							setPage(pageNumber);
						}
						setSidebarLoadingLabel('loading');
						payload = { ...payload, parentName: "Unlabeled Document", page: pageNumber, otherDocuments: true, myAssigned: myAssigned, }
						dispatch(appendDocumentsById(payload, ((result) => {
							if (result?.docs && result?.docs.length) {
								if (result.docs[i]) {
									_moveToNextId(result.docs[i]._id)
									setHasPrevPage(result?.hasPrevPage)
									setSelectedId(result?.docs[i]?._id);
									setHasNextPage(result?.hasNextPage)
									setSidebarLoading(false);
									setSidebarLoadingLabel('View More');
									setShowModel(false)

								} else {
									_moveToNextId(result.docs[0]._id)
									setHasPrevPage(result?.hasPrevPage)
									setSelectedId(result?.docs[0]?._id);
									setHasNextPage(result?.hasNextPage)
									setSidebarLoading(false);
									setSidebarLoadingLabel('View More');
									setShowModel(false)

								}


							} else {
								history.push("/documents");

							}

						})));
					}

				}))
			}
		})
	}


	return (
		<>
			<div className="page-header border-0 income-analyzer-header d-flex align-items-center responsive-menu-btn">
				<h2>D.E.N.N.i.S</h2>
				<div className="right-col ms-auto">

				</div>
				<BackButton className="ms-auto" onClick={() => backClick()} />
			</div>
			<div className="documents-wrapper tab-layout d-flex flex-fill overflow-auto position-relative document-management-wrapper">
				<div className=
					{`left-col d-flex flex-column overflow-auto sidebar-list-col 
				${navigationState ? 'active' : ''}
				`}>
					{files &&
						<SidebarList
							hasPrevPage={hasPrevPage}
							hasNextPage={hasNextPage}
							title={currentDocument?.complete == true || currentDocument?.reviewLabeled == true ? "Labled Document" : "Unlabled Document"}
							filterSelected={filterSelected}
							sortBySelected={sortBySelected}
							filterSelectedFn={(val) => filterSelectedFn(val)}
							sortBySelectedFn={(val) => sortBySelectedFn(val)}
							sortFn={sortFn} sidebarLoading={sidebarLoading} sidebarLoadingLabel={sidebarLoadingLabel}
							_filter={_advanceFilter}
							_loader={loader}
							__filter={(sortBy, order) => __advanceFilter(sortBy, order)}
							_resetFilter={_resetFilter}
							sidbarLoadingButton={sidbarLoadingButton} page={page} handlePageChange={(page, reviewRequested, otherDocuments) => _handlePageChange(page, reviewRequested, otherDocuments)} list={files} handleSelectedAction={(id) => _handleSelected(id)} search={(val) => _docSearch(val)} _innerLodder={innerLoader} handleElasticSearch={(val) => _elasticSearch(val)} elasticSearchList={elasticSearchList} focusSearchFlag={focusSearchFlag} _focusSearch={(val) => focusSearch(val)} totalDocRecords={totalDocRecords} />
					}
				</div>
				<div className="mid-col d-flex flex-column flex-fill overflow-auto position-relative">
					<div className="inner-blc d-flex flex-column flex-fill overflow-auto">
						{/* {console.log("currentDocument",currentDocument)} */}
						{!loader && Object.keys(currentDocument).length ? (
							<DocumentView
								fileData={currentDocument} page={pageNumber} userName={userName} />

						) : (null)}

						{loader && <LoaderUI message={true} FullWindow={false} inContainer={true} loadingMessage={"Loading..."} />
						}

					</div>
				</div>
				<div className="right-column d-flex flex-column overflow-auto position-relative" style={{ background: bgColor }}>

					{!loader && Object.keys(currentDocument).length ? (
						<DennisFile onBgColorChange={setBgColor} totalDocRecords={totalDocRecords} nextDocFlag={((val) => nextDoc(val))} draftJsonFlag={(val) => setDraftJsonFlag(val)} draftJson={(data) => setDraft(data)} updateDocumentViewData={updateDocumentViewData} fileData={currentDocument} modelData={modelData} markCompleted={(id, version) => markCompleted(id, version)} />

					) : (null)}
				</div>
			</div>
			<DraftUnlabeledData showModal={showModal} setShowModel={(val) => changeFile()} _makeDocDraft={() => { makeDraft() }} />
		</>
	)
};
export default UnlabeledDocumentDetail;